import { adminService } from "./adminService";

export const metricsService = {
  getMetrics: adminService.getDashboardMetrics,
};
